import { render } from "./ListeningReview.vue?vue&type=template&id=1bcb69c2&scoped=true"
import script from "./ListeningReview.vue?vue&type=script&lang=js"
export * from "./ListeningReview.vue?vue&type=script&lang=js"

import "./ListeningReview.vue?vue&type=style&index=0&id=1bcb69c2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bcb69c2"]])

export default __exports__